import minAct from '../../assets/images/minAct.svg';
import maxBeauty from '../../assets/images/maxBeauty.svg';
import womanOranges from '../../assets/images/womanOranges.png';
import Variants from './services/variants.tsx';
import WhyUs from './services/whyUs.tsx';

function services() {
  return ( 
    <div className='services' id='services'>
      <div className='services__background'></div>
      <div className='services__background-bottom'></div>
      <div className='services__header'>
        <img className='services__header-image' src={minAct} alt="Минимум действий" />
        <img className='services__header-image' src={maxBeauty} alt="Максимум красоты" />
        <img className='services__header-woman' src={womanOranges} alt="Девушка с апельсинами" />
      </div>
      <div className='services__list'>
        <Variants />
      </div>
      <div className='services__button'>
        <a className='services__button-link' href="#prices">УЗНАТЬ ЦЕНЫ</a>
      </div>
      <WhyUs />
    </div>
   );
}

export default services;